export default "__VITE_ASSET__CfRCGPu7__"